import { computed } from 'vue'
import { useProjectStore, type Project } from '@/stores/project'

/** Reads/writes the current project from the project store. Used by sidebar nav + ProjectDetail. */
export function useProjectSidebarContext() {
  const projectStore = useProjectStore()

  const activeProjectId = computed(() => projectStore.currentProjectId)
  const activeProjectTitle = computed(() => projectStore.currentProject?.name || null)

  function setActiveProject(id: string | null, title?: string | null, data?: Project | null) {
    const projectData = data ?? (id && title ? { id, name: title } : null)
    projectStore.setCurrentProject(id, projectData)
  }

  function clearActiveProject() {
    projectStore.clearCurrentProject()
  }

  return {
    activeProjectId,
    activeProjectTitle,
    setActiveProject,
    clearActiveProject,
  }
}
